var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods row_flex"},_vm._l((_vm.goods),function(item){return _c('GoodsItem',{key:item.index,attrs:{"good":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }